export const euro = (n) => {
    if (n === null || n === undefined || n === "") return "—";
    const num = typeof n === "number" ? n : parseFloat(n);
    if (Number.isNaN(num)) return "—";
    return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
    }).format(num);
};

export const germanDate = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }).format(d);
    } catch {
        return iso;
    }
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const PHASES = [
    { id: 1, key: "kuendigung", title: "Kündigung & Strategie", short: "Kündigung" },
    { id: 2, key: "vorabnahme", title: "Vorabnahme & Foto-Referenz", short: "Vorabnahme" },
    { id: 3, key: "uebergabe", title: "Die Übergabe (Daten-Hub)", short: "Übergabe" },
    { id: 4, key: "abschluss", title: "Abschluss & Kautionsabrechnung", short: "Abschluss" },
];

export const ASSET_TYPES = [
    { value: "ETW", label: "ETW — Eigentumswohnung" },
    { value: "MFH", label: "MFH — Mehrfamilienhaus" },
    { value: "MFH_gemischt", label: "MFH (gemischt) — Wohnen + Gewerbe" },
    { value: "Gewerbe", label: "Gewerbeobjekt" },
    { value: "Garagen", label: "Garagen-Komplex" },
    { value: "Stellplätze", label: "Stellplätze" },
];

export const UNIT_TYPES = [
    { value: "wohnung", label: "Wohnung", group: "haupt" },
    { value: "gewerbe", label: "Gewerbe", group: "haupt" },
    { value: "garage", label: "Garage", group: "zubehoer" },
    { value: "stellplatz", label: "Stellplatz", group: "zubehoer" },
    { value: "dachterrasse", label: "Dachterrasse", group: "zubehoer" },
    { value: "dachflaeche", label: "Dachfläche", group: "zubehoer" },
    { value: "spitzboden", label: "Spitzboden", group: "zubehoer" },
    { value: "mansarde", label: "Mansarde", group: "zubehoer" },
    { value: "aussenflaeche", label: "Außenfläche", group: "zubehoer" },
    { value: "garten", label: "Garten", group: "zubehoer" },
    { value: "kellerraum", label: "Kellerraum", group: "zubehoer" },
    { value: "fassade", label: "Fassade", group: "zubehoer" },
    { value: "sonstiges", label: "Sonstiges (Freitext)", group: "zubehoer" },
    // Ein Zimmer ist weder Haupteinheit noch Zubehoer, sondern ein Teil einer
    // Wohnung, die zimmerweise vermietet wird (Auftrag 4, Nachtrag 7). Es
    // haengt wie Zubehoer an parent_unit_id, traegt aber einen eigenen
    // Mietvertrag -- deshalb eine eigene Gruppe und nicht "zubehoer".
    { value: "zimmer", label: "Zimmer (Einzelvermietung)", group: "zimmer" },
];

export const HAUPT_TYPES = ["wohnung", "gewerbe"];
export const ZUBEHOER_TYPES = UNIT_TYPES.filter((u) => u.group === "zubehoer").map((u) => u.value);
export const ZIMMER_TYP = "zimmer";

export const NUTZUNGSARTEN = [
    { value: "sondernutzungsrecht", label: "Sondernutzungsrecht — gehört zu einer Wohnung" },
    { value: "zubehoer", label: "Zubehör — gehört zu einer Wohnung" },
    { value: "gesamtobjekt", label: "Gesamtobjekt — gehört zum nicht-aufgeteilten Gebäude" },
    { value: "einzelzimmer", label: "Einzelzimmer — ein Zimmer einer zimmerweise vermieteten Wohnung" },
];

// Wie eine Wohnung vermietet wird. "ganz" ist die Vorgabe und gilt auch, wenn
// das Feld fehlt -- der Bestand vor dem 13.10.2026 aendert sich dadurch nicht.
//
// Das ist ein ZUSTAND, keine Erlaubnis: An einer Einzelzimmer-Wohnung haengt
// kein eigener Mieter, an einem Zimmer einer ganz vermieteten Wohnung auch
// nicht, und umgeschaltet wird nur, wenn nichts mehr laeuft. Eine Erlaubnis
// ("hier duerfen mehrere Vertraege sein") wuerde eine Pruefung aufheben; ein
// Zustand laesst sich pruefen.
export const VERMIETUNGSARTEN = [
    { value: "ganz", label: "Als Ganzes — ein Mietvertrag über die Wohnung" },
    { value: "einzelzimmer", label: "Zimmerweise — je Zimmer ein eigener Mietvertrag" },
];

// "Unbekannt" ist kein fehlender Wert, sondern eine Aussage: zu dieser Einheit
// fehlen die Mieterdaten. Nur so lässt sich bestätigter Leerstand von einer
// Datenlücke unterscheiden — vorher zählten beide als "vermietet".
export const UNIT_STATUSES = [
    { value: "vermietet", label: "Vermietet" },
    { value: "leer", label: "Leer (bestätigt)" },
    { value: "unbekannt", label: "Unbekannt — Mieterdaten fehlen" },
    { value: "in_uebergabe", label: "In Übergabe" },
];

export const LEGAL_FORMS = ["privat", "GbR", "GmbH", "eG", "Stiftung", "KG", "Sonstige"];

export const WIKI_CATEGORIES = [
    { value: "handwerker-kontakte", label: "Handwerker & Kontakte" },
    { value: "schaeden-reparaturen", label: "Schäden & Reparaturen" },
    { value: "prozesse-ablaeufe", label: "Prozesse & Abläufe" },
    { value: "objekt-doku", label: "Objekt-Doku" },
    { value: "verkauf-notariat", label: "Verkauf & Notariat" },
    { value: "sonstiges", label: "Sonstiges" },
];

export const statusLabel = (s) => {
    const map = {
        offen: "Offen",
        in_bearbeitung: "In Bearbeitung",
        abgeschlossen: "Abgeschlossen",
        aktiv: "Aktiv",
        gekuendigt: "Gekündigt",
        ausgezogen: "Ausgezogen",
        berechnet: "Berechnet",
        ausgezahlt: "Ausgezahlt",
        vermietet: "Vermietet",
        leer: "Leer",
        unbekannt: "Unbekannt",
        in_uebergabe: "In Übergabe",
        wohnung: "Wohnung",
        gewerbe: "Gewerbe",
        garage: "Garage",
        stellplatz: "Stellplatz",
        dachterrasse: "Dachterrasse",
        dachflaeche: "Dachfläche",
        spitzboden: "Spitzboden",
        mansarde: "Mansarde",
        aussenflaeche: "Außenfläche",
        garten: "Garten",
        kellerraum: "Kellerraum",
        fassade: "Fassade",
        sonstiges: "Sonstiges",
        sondernutzungsrecht: "Sondernutzungsrecht",
        zubehoer: "Zubehör",
        gesamtobjekt: "Gesamtobjekt",
    };
    return map[s] || s;
};

export const statusTone = (s) => {
    const map = {
        offen: "warning",
        in_bearbeitung: "info",
        abgeschlossen: "success",
        aktiv: "success",
        gekuendigt: "warning",
        ausgezogen: "muted",
        berechnet: "info",
        ausgezahlt: "success",
        vermietet: "success",
        leer: "muted",
        unbekannt: "warning",
        in_uebergabe: "warning",
    };
    return map[s] || "muted";
};

/**
 * Läuft dieses Mietverhältnis am Stichtag? Spiegelt ist_aktiv() im Backend.
 *
 * Der Status allein genügt nicht: ein Auszugsdatum in der Vergangenheit
 * beendet das Mietverhältnis, auch wenn niemand den Status nachgezogen hat.
 * Genau daran lag es, dass eine Wohnung mit Auszug zum 31.07.2026 weiter als
 * vermietet mit dieser Mieterin dastand.
 */
// Aus dem Freitext des Grundbuch-Eintrags die Blattnummer holen.
// Im Bestand steht dort "Grundbuch von Aachen, Blatt 17610" -- in einer
// Tabellenspalte zaehlt davon nur das Blatt; der ganze Satz passt in den
// Tooltip. Findet sich kein Blatt, wird der Text selbst gezeigt: lieber
// unerwartet als gar nichts.
export const grundbuchblatt = (text) => {
    if (!text) return null;
    const m = /blatt\s*([0-9][0-9\s–—\-,./]*)/i.exec(text);
    return m ? `Blatt ${m[1].trim().replace(/[,.]+$/, "")}` : text;
};

export const istAktivesMietverhaeltnis = (t, stichtag = null) => {
    if (!t) return false;
    const tag = stichtag || new Date().toISOString().slice(0, 10);
    const st = (t.status || "").toLowerCase();
    if (["ausgezogen", "inaktiv"].includes(st)) return false;
    if (t.auszugsdatum && t.auszugsdatum < tag) return false;
    if (t.einzugsdatum && t.einzugsdatum > tag) return false;
    return true;
};
